import { CompleteStore } from '../../../../../reducers/reducerTypes';
import { CategoryType } from '../../storeTypes';

export const getAvailableCategories = (state: CompleteStore): Array<CategoryType> => {
	return state.info.availableCategories;
};
